export const enum StockTypeSeparationTrackingEvent {
  SWITCHER_RENDERED = 'stock-type-separation-switcher-rendered',
  SWITCHER_USED = 'stock-type-separation-switcher-used',
  NOTIFICATION_RENDERED = 'stock-type-separation-notification-rendered',
  CREATE_NEW_SELECTION_CHOSEN = 'stock-type-separation-create-new-selection-chosen',
  SHOP_ANYWAY_CHOSEN = 'stock-type-separation-shop-anyway-chosen',
  NOTIFICATION_DISMISSED = 'stock-type-separation-notification-dismissed',
}
